module.exports = __webpack_public_path__ + "img/welcomes-preview-text-fanli-2.aeb1feb1.png";